import {Polyline} from "@react-google-maps/api";
import React from "react";
import {DriverLocationEntity, GeoCoord} from "@ots-frontend/ots-data";

export type ShiftRoutePolylineProps = {
  id: string,
  color?: string,
  route: (DriverLocationEntity | GeoCoord)[]
}

export const ShiftRoutePolyline = (props: ShiftRoutePolylineProps) => {
  const {id, color = "#2da711", route} = props;
  return (
    <Polyline
      key={id}
      path={route.map((crd) => {
        return {lat: crd.latCoord, lng: crd.longCoord};
      })}
      options={{
        strokeColor: color,
      }}
    />
  );
};

export const ShiftRoutePolylineMemo = React.memo(ShiftRoutePolyline);
